@if (isLoading()) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
